<div class="numeric-stepper">
  <button
    role="button"
    [disabled]="disabled || !canDecrement"
    [ngClass]="{ active: canDecrement, pointer: canDecrement }"
    (click)="decrement()"
    [attr.aria-label]="'shared.decrement' | translate"
  >
    <i [class]="decrementIcon"></i>
  </button>
  <ng-container *ngIf="inputField && !disabled; else staticValueTemplate">
    <input
      #quantityInput
      (keydown.enter)="quantityInput.blur()"
      digitOnly
      [id]="inputId"
      [class]="quantityClass"
      type="number"
      (input)="onInput($event)"
      (change)="onChange($event)"
      (focus)="selectInput($event)"
      (keydown)="onKeyDown($event)"
      [size]="maxQuantity.toString().length"
      [maxLength]="maxQuantity.toString().length"
      [disabled]="disabled"
      [value]="quantity"
      [attr.aria-disabled]="disabled ? 'true' : null"
      [attr.aria-label]="ariaLabel"
    />
  </ng-container>
  <button
    role="button"
    [disabled]="disabled || !canIncrement"
    [ngClass]="{ active: canIncrement, pointer: canIncrement }"
    (click)="increment()"
    [attr.aria-label]="'shared.increment' | translate"
  >
    <i [class]="incrementIcon"></i>
  </button>
</div>
<ng-content></ng-content>

<ng-template #staticValueTemplate>
  <span [class]="quantityClass">{{ quantity }}</span>
</ng-template>
